import React, { useEffect, useState } from "react";
import LiveIcon from "../../../../../../assets/images/Souvenir/live.png";
import axios from "axios";
import AuctionNav from "./AuctionNav/AuctionNav";
import LoaderPost from "../../../../../Reuseable/LoaderPost";
import ProductCard from "./Content/ProductCard";

const PendingProductList = () => {
  const [pendingProduct, setPendingProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axios.get(`/api/admin/pending/auction/product`).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        setPendingProduct(res.data.pending_product);
      }
    });
  }, []);

  return (
    <>
      <AuctionNav />

      <div className="d-flex mb-4  head-line p-3">
        <div className=" d-flex">
          <img src={LiveIcon} className=" SouvenirIcon" alt="" />
        </div>
        <div className=" d-flex text-light fw-bold mt-1 mx-3 ">
          Pending Product
        </div>
      </div>

      {loading ? (
        <LoaderPost />
      ) : (
        <ProductCard data={pendingProduct} noBidder="true" unsold="true" />
      )}
    </>
  );
};

export default PendingProductList;

{
  /* <ProductCardStar data={pendingProduct} noBidder="true" unsold="true" /> */
}
// to={`/superstar/auction/approvedOrDecline/${product.id}`}
